import { render, staticRenderFns } from "./stockIn.vue?vue&type=template&id=333cecfc&scoped=true"
import script from "./stockIn.vue?vue&type=script&lang=js"
export * from "./stockIn.vue?vue&type=script&lang=js"
import style0 from "./stockIn.vue?vue&type=style&index=0&id=333cecfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333cecfc",
  null
  
)

export default component.exports